import { PsychometricEvaluationStatus } from "src/app/@core/constants";

export class PsychometricEvaluationResponse {
    status: PsychometricEvaluationStatus;
    message: string;
    code: string;

    constructor() {
        this.status = PsychometricEvaluationStatus.PENDING;
        this.message = "Pendiente";
        this.code = "";
    }
}